export default "__VITE_ASSET__d66c8bd7__"